export const PAGE_SIZE = [5, 20, 50];
